import { render } from "./index.vue?vue&type=template&id=6624e75a&bindings={}"
import script from "./About.js?vue&type=script&lang=js"
export * from "./About.js?vue&type=script&lang=js"

import "./About.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script